import type { Batch } from '@ctcells/contract'
import { t } from '@ctcells/i18n'

import { ValueRows } from '../../atoms/ValueRows.tsx'

import { haltFactRows } from './haltFactRows.tsx'

/**
 * **멈춤 정보**(작업 상세 · 백엔드 0.28.15 · eric 2026-10-22) — 멈춘 배치의 시간 줄 · 까닭 모듈 · 원격 호출 예정 시각.
 *
 * | 줄 | 서버 칸 |
 * | --- | --- |
 * | 멈춘 시각 | `halt_delay.since` |
 * | 멈춘 시간 | `halt_delay.elapsed_paused_sec`(최신 체크포인트의 누적) |
 * | 허용 지연 | `halt_delay.max_allowed_delay_sec` |
 * | 지연 판정 | `halt_delay.state`(ok · warn · exceeded · inconclusive) |
 * | 멈춘 모듈 | `halt_module_id` — 모듈 상세 링크 |
 * | 원격 호출 예정 | `halt_remote_at` |
 *
 * 🔴 **화면이 세지 않는다.** 시간은 서버가 계산해 실은 값 그대로다 — 지금 시각으로 빼거나 시계를 돌리지 않는다
 *    (계약 「화면이 세지 않도록 서버가 계산해 싣는다」). 다음 스냅샷 · 구독(`batch_status`)이 값을 바꾼다.
 * 🔴 **없는 칸은 줄째 없다** — `—` 로 채운 줄을 깔지 않는다(「화면의 내용은 API 응답이 정한다」). 다 없으면 아무것도 안 그린다.
 * ⚠ 지연 판정은 «판정 입력이 아니다»(판정은 `recovery_verdict`) — 보이기만 한다.
 */
export function HaltFacts({
  batch,
  onOpenModule,
}: {
  batch: Pick<Batch, 'halt_code' | 'halt_delay' | 'halt_module_id' | 'halt_remote_at'>
  /** 멈춘 모듈 → 그 모듈 상세. 셸이 길을 줄 때만 링크다(아니면 글자) */
  onOpenModule?: ((moduleId: string) => void) | undefined
}) {
  const rows = haltFactRows(batch, onOpenModule)
  if (rows.length === 0) return null
  return (
    <section aria-label={t('halt.facts')} className="halt-facts">
      <ValueRows rows={rows} />
    </section>
  )
}
